export enum ConnectorNames {
  Injected = "injected",
}
